unit App.Web.Utils;

interface

uses
  App.Enumerations,
  App.Shared;

/// <summary>
///  Standard edit-form scope requirement shared across CATSC edit pages.
/// </summary>
function GetStandardEditLevel: string;

implementation

uses
  System.SysUtils;

function GetStandardEditLevel: string;
begin
  Result :=
    USER_SCOPES[TUserScope.Administrator] + ',' +
    USER_SCOPES[TUserScope.Customer];

end;

end.
